// extracted by extract-css-chunks-webpack-plugin
module.exports = {"storeDetails":"-Nzgz","phoneNumber":"-MqhB"};